export const removeWhitespace = (value: string): string => value.replace(/\s+/g, '');
